import { useTranslation } from 'react-i18next';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full min-h-screen flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20macro%20textile%20photography%20of%20fine%20woven%20natural%20linen%20fibers%20in%20warm%20cream%20and%20sand%20tones%2C%20extremely%20shallow%20depth%20of%20field%20creating%20dreamy%20soft%20blur%20effect%2C%20delicate%20fabric%20texture%20with%20subtle%20organic%20imperfections%2C%20warm%20golden%20hour%20backlight%20creating%20ethereal%20luminous%20glow%2C%20artistic%20editorial%20style%20with%20minimalist%20composition%2C%20pure%20serene%20atmosphere%20with%20gentle%20warm%20neutral%20palette&width=1800&height=1200&seq=hero-bg-v2-july&orientation=landscape"
          alt="Kakobuy Finds - tekstura tła"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6 lg:px-10 pt-20 md:pt-24">
        <div className="max-w-3xl">
          {/* Badge */}
          <span className="inline-block px-4 py-1.5 border border-background-50/40 text-background-50 text-xs font-medium rounded-full mb-6 md:mb-8 tracking-wide">
            {t('hero_badge')}
          </span>

          {/* Title */}
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-6 md:mb-8">
            {t('hero_title')}
          </h1>

          {/* Subtitle */}
          <p className="text-base md:text-lg text-background-50/80 leading-relaxed mb-8 md:mb-10 max-w-xl">
            {t('hero_subtitle')}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-background-50 text-foreground-900 font-semibold text-sm rounded-lg hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer"
            >
              {t('btn_view_spreadsheet')}
              <i className="ri-arrow-right-line"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-accent-500 text-background-50 font-semibold text-sm rounded-lg hover:bg-accent-600 transition-all whitespace-nowrap cursor-pointer"
            >
              {t('btn_buy_now')}
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2">
        <span className="text-background-50/60 text-xs tracking-widest uppercase">Scroll</span>
        <i className="ri-arrow-down-line text-background-50/60 animate-bounce"></i>
      </div>
    </section>
  );
}